import React, { useContext, useEffect, useState } from "react";
import { Menu, type MenuProps, theme, Tag } from "antd";
import Sider from "antd/es/layout/Sider";
import { RiBrainLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { Gi3DMeeple, GiDivingDagger } from "react-icons/gi";
import { AuthContext } from "../../../../config/AuthContext";
import { TbMeeple } from "react-icons/tb";
import { LuListTodo } from "react-icons/lu";
import { PiExam } from "react-icons/pi";

interface Props {
    currentVal: number,
    setPantalla: (value: number, isSprint: boolean, sprint: string) => void;
    sprints: any[];
}

const AppSiderProjectesId = (props: Props) => {
    const [pantalla, setPantalla] = useState<any>(props.currentVal);

    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {

        document.title = 'Web Dubtes';
    }, [props.sprints]);

    const titlesAlu: string[] = ['Grup', 'Tasques', 'Validació'];

    const items2: MenuProps['items'] = [TbMeeple, LuListTodo, PiExam].map(
        (icon, index) => {
            const key = String(index + 1);

            const children = titlesAlu[index] === 'Tasques'
                ? (props.sprints || []).map((sprint, sprintIndex) => {
                    const now = new Date();

                    // Helper to safely parse SQL-like dates (YYYY-MM-DD HH:mm:ss) to ISO
                    const parseDate = (dateStr: string) => {
                        if (!dateStr) return null;
                        const safeStr = dateStr.replace(' ', 'T');
                        const d = new Date(safeStr);
                        return isNaN(d.getTime()) ? null : d;
                    };

                    const start = parseDate(sprint.data_inici);
                    const end = parseDate(sprint.data_final);

                    let statusColor = 'default';
                    let statusText = 'No iniciat';

                    if (start && end) {
                        if (now < start) {
                            statusColor = 'default';
                            statusText = 'No iniciat';
                        } else if (now >= start && now <= end) {
                            statusColor = 'success';
                            statusText = 'En curs';
                        } else {
                            statusColor = 'error';
                            statusText = 'Tancat';
                        }
                    } else {
                        // Fallback using explicit status if dates are missing/invalid
                        if (sprint.estado === 'cerrado') {
                            statusColor = 'error';
                            statusText = 'Tancat';
                        } else if (sprint.estado === 'abierto') {
                            statusColor = 'success';
                            statusText = 'En curs';
                        }
                    }

                    // Determine label content
                    const label = (
                        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2', padding: '4px 0' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span>Sprint {sprint.numero}: {sprint.label}</span>
                                <Tag color={statusColor} style={{ margin: 0, fontSize: '10px', lineHeight: '14px' }}>{statusText}</Tag>
                            </div>
                            {start && end && (
                                <span style={{ fontSize: '10px', color: '#888' }}>
                                    {start.toLocaleDateString()} - {end.toLocaleDateString()}
                                </span>
                            )}
                        </div>
                    );

                    return {
                        key: `sp-${sprint.id}`,
                        label: label,
                        onClick: () => {
                            props.setPantalla(sprintIndex, true, sprint.id);
                            setPantalla("sp-" + sprintIndex);
                        }
                    };
                })
                : undefined;

            return {
                key: key,
                icon: React.createElement(icon),
                label: titlesAlu[index],
                onClick: () => {
                    if (titlesAlu[index] !== 'Tasques') {
                        setPantalla(index + "");
                        props.setPantalla(index, false, '');
                    }
                },
                children: children
            };
        },
    );

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    return (
        <Sider style={{ background: colorBgContainer }} width={200}>
            <Menu
                mode="inline"
                defaultSelectedKeys={[(pantalla + 1) + ""]}
                defaultOpenKeys={['sub1']}
                style={{ height: '100%' }}
                items={items2}
            />
        </Sider>
    );
}

export default AppSiderProjectesId;